module.exports = __webpack_public_path__ + "img/lgsquare.7322d04e.png";